import { useTranslation } from 'react-i18next';
import { Grid, Typography } from '@mui/material';
import LabelValue from '../../LabelValue';
import { DriverPhoneNumber } from '../../../data/models/phone-number.model';
import { usePhone } from '../../../hooks/usePhone';
import { FULLSTORY_MASK_CLASSNAME } from '../../../services/analyticsUtils';

interface EmergencyContactInfoProps {
  phone?: DriverPhoneNumber;
  titleStyle: string;
}

export default function EmergencyContactInfo(props: EmergencyContactInfoProps) {
  const { t } = useTranslation('common');

  const { phone, titleStyle } = props;

  return (
    <>
      <Typography className={titleStyle}>
        {t('driver.emergencyContact')}
      </Typography>
      <Grid container spacing={2} className={FULLSTORY_MASK_CLASSNAME}>
        <Grid item sm={12} md={6}>
          <LabelValue
            label={t('common.firstName')}
            value={phone?.contactFirstName}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue
            label={t('common.lastName')}
            value={phone?.contactLastName}
          />
        </Grid>
        <Grid item sm={12} md={6}>
          <LabelValue label={t('common.phone')} value={usePhone(phone)} />
        </Grid>
      </Grid>
    </>
  );
}
